var _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5d4037",
    points: "26,16 3,9 5,35 26,46 43,34 45,8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8d6e63",
    points: "3,9 5,35 26,46 26,16"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#43a047",
    points: "28,22.158 28,18 30,17.127 30,20 32,19 32,23 35,21.772 35,15 37,14.151 37,19 39,18.177 39,16 41,15 41,12.467 43,11.625 43,14 44.6,13.2 45,8 26,16 26,23"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2ff59",
    points: "3,9 23,3 45,8 26,16"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#66bb6a",
    points: "3,9 3.4,14.134 5,14.607 5,13.413 7,14 7,17.217 10,18.13 10,13.373 12,14 12,18.739 14,19.348 14,16.449 16,17.058 16,19.957 18,20.565 18,19.379 20,20 20,18.424 22,19 22,21.783 26,23 26,16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoil);
export default __webpack_public_path__ + "static/media/Soil.12dbf75aa0e1fb6b8d2f96d75986dcc0.svg";
export { ForwardRef as ReactComponent };